import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { concludeDesignExperiment, fetchActiveDesignExperiment, fetchDesignExperimentResults, startDesignExperiment, } from '@/services/design-experiment';
const ACTIVE_EXPERIMENT_KEY = (campaignPublicId) => ['design-experiments', 'active', campaignPublicId];
const EXPERIMENT_RESULTS_KEY = (campaignPublicId, experimentPublicId, from, to) => ['design-experiments', 'results', campaignPublicId, experimentPublicId, from, to];
export const useActiveDesignExperiment = (campaignPublicId) => useQuery({
    queryKey: ACTIVE_EXPERIMENT_KEY(campaignPublicId),
    queryFn: () => fetchActiveDesignExperiment(campaignPublicId),
});
export const useDesignExperimentResults = (args) => {
    const { campaignPublicId, experimentPublicId, from, to, excludeDevices, excludeBrowsers, enabled } = args;
    return useQuery({
        queryKey: EXPERIMENT_RESULTS_KEY(campaignPublicId, experimentPublicId, from, to),
        queryFn: () => {
            // experimentPublicId is non-null here because `enabled` gates it.
            if (!experimentPublicId) {
                throw new Error('experimentPublicId is required to fetch results');
            }
            return fetchDesignExperimentResults({
                campaignPublicId,
                experimentPublicId,
                from,
                to,
                excludeDevices,
                excludeBrowsers,
            });
        },
        enabled: !!experimentPublicId && (enabled ?? true),
        // Live polling — surfaces incoming scans without manual refresh while
        // the experiment runs.
        refetchInterval: 30_000,
    });
};
export const useStartDesignExperiment = (campaignPublicId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: startDesignExperiment,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ACTIVE_EXPERIMENT_KEY(campaignPublicId) });
        },
    });
};
export const useConcludeDesignExperiment = (campaignPublicId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: concludeDesignExperiment,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ACTIVE_EXPERIMENT_KEY(campaignPublicId) });
            // Campaign columns just changed (winner promoted) → re-fetch the
            // campaign so detail / customize pages reflect it.
            queryClient.invalidateQueries({ queryKey: ['campaign', campaignPublicId] });
        },
    });
};
